/* Glossary hover-cards. Upgrades plain links to glossary pages (handles from
   [data-glossary-handles]) inside .rte / .site-drawer__content /
   [data-glossary-scope]. Desktop: hover-intent fetch of ?view=hover (cached).
   Touch (<=1024px): first tap opens the card, outside tap closes. */
(function () {
  'use strict';
  var dataEl = document.querySelector('[data-glossary-handles]');
  if (!dataEl) return;
  var handles;
  try { handles = new Set(JSON.parse(dataEl.textContent)); } catch (e) { return; }
  if (!handles.size) return;

  var READ_MORE = dataEl.getAttribute('data-read-more') || 'Διαβάστε περισσότερα';
  var cache = {};   // handle -> Promise<payload>
  var card = null, openFor = null, hideTimer = null, hoverTimer = null;

  function isTouch() { return window.matchMedia('(max-width: 1024px)').matches; }

  function handleOf(a) {
    var m = a.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/pages\/([^\/]+)\/?$/i);
    return m && handles.has(m[1]) ? m[1] : null;
  }

  function fetchHover(handle, a) {
    if (!cache[handle]) {
      cache[handle] = fetch(a.pathname + '?view=hover', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { delete cache[handle]; return null; });
    }
    return cache[handle];
  }

  function ensureCard() {
    if (card) return card;
    card = document.createElement('div');
    card.className = 'glossary-card';
    card.setAttribute('role', 'tooltip');
    document.body.appendChild(card);
    card.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    card.addEventListener('mouseleave', scheduleHide);
    return card;
  }

  function show(a, data) {
    if (!data) return;
    var c = ensureCard();
    c.innerHTML =
      (data.image ? '<img class="glossary-card__img" src="' + data.image + '" alt="">' : '') +
      '<div class="glossary-card__body"><p class="glossary-card__title"></p>' +
      '<div class="glossary-card__excerpt">' + (data.excerpt_html || '') + '</div>' +
      '<a class="glossary-card__more"></a></div>';
    c.querySelector('.glossary-card__title').textContent = data.title;
    var more = c.querySelector('.glossary-card__more');
    more.href = data.url; more.textContent = READ_MORE;
    if (!isTouch()) {
      var r = a.getBoundingClientRect();
      var top = r.bottom + window.scrollY + 8;
      var left = Math.min(r.left + window.scrollX, window.scrollX + document.documentElement.clientWidth - 336);
      if (r.bottom + 240 > window.innerHeight && r.top > 260) top = r.top + window.scrollY - 8 - 240;
      c.style.top = top + 'px';
      c.style.left = Math.max(12, left) + 'px';
    }
    c.classList.add('is-open');
    openFor = a;
  }

  function hide() { if (card) card.classList.remove('is-open'); openFor = null; }
  function scheduleHide() { hideTimer = setTimeout(hide, 200); }

  function upgrade(a, handle) {
    a.classList.add('glossary-link');
    a.addEventListener('click', function (e) {
      if (!isTouch()) return;
      if (openFor === a) return;         // second tap navigates
      e.preventDefault();
      fetchHover(handle, a).then(function (d) { show(a, d); });
    });
    a.addEventListener('mouseenter', function () {
      if (isTouch()) return;
      clearTimeout(hideTimer);
      hoverTimer = setTimeout(function () {
        fetchHover(handle, a).then(function (d) { if (a.matches(':hover')) show(a, d); });
      }, 150);
    });
    a.addEventListener('mouseleave', function () {
      if (isTouch()) return;
      clearTimeout(hoverTimer);
      scheduleHide();
    });
  }

  var SCOPE = '.rte, .site-drawer__content, [data-glossary-scope]';
  function check(a) {
    if (a.dataset.glossaryDone || !a.closest(SCOPE)) return;
    var h = handleOf(a);
    if (h) { a.dataset.glossaryDone = '1'; upgrade(a, h); }
  }

  function scan() {
    document.querySelectorAll('.rte a, .site-drawer__content a, [data-glossary-scope] a').forEach(check);
  }

  // Later DOM changes: only the ADDED subtrees are scanned, once per frame. Re-querying the whole
  // document on every mutation cost 10-30 ms at 4x mobile CPU per filter click and per paged
  // top-up chunk on a 22k-node collection page (WORK-241).
  var added = [], queued = false;
  function scanAdded() {
    queued = false;
    var roots = added; added = [];
    for (var i = 0; i < roots.length; i++) {
      var n = roots[i];
      if (!n.isConnected) continue;
      if (n.matches('a')) check(n);
      n.querySelectorAll('a').forEach(check);
    }
  }

  document.addEventListener('click', function (e) {
    if (openFor && card && !card.contains(e.target) && e.target !== openFor) hide();
  });
  scan();
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var nodes = records[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) if (nodes[j].nodeType === 1) added.push(nodes[j]);
    }
    if (added.length && !queued) { queued = true; requestAnimationFrame(scanAdded); }
  }).observe(document.body, { childList: true, subtree: true });
})();
